export const model = {
  title: '',
  state: ''
};